import { trackClickedAttr } from './snippet-attributes';

export type TrackClickedData = {
  name: string;
  properties?: Record<string, string>;
};

export function getTrackClickedDataFromElement(
  el: HTMLElement,
): TrackClickedData | null {
  const name = el.getAttribute(trackClickedAttr);
  if (!name) return null;

  const properties: Record<string, string> = {};

  const attributeNames = el
    .getAttributeNames()
    .filter((attr) => attr.startsWith(`${trackClickedAttr}-`));

  for (const attrName of attributeNames) {
    const value = el.getAttribute(attrName);
    if (value) properties[attrName.slice(trackClickedAttr.length + 1)] = value;
  }

  if (el.tagName === 'a') {
    const href = el.getAttribute('href');
    if (href) properties.url = href;
  }

  return { name, properties };
}

export function getTrackClickedAttributes(data: TrackClickedData) {
  const attributes: Record<string, string> = {
    [trackClickedAttr]: data.name,
  };

  if (data.properties) {
    for (const [key, value] of Object.entries(data.properties)) {
      attributes[`${trackClickedAttr}-${key}`] = value;
    }
  }

  return attributes;
}
